import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"arrow-down\">\n  <path d=\"M27.27 34.47L46.1 65.53h7.89l18.74-31.06H61.28L50.09 54.93h-.18L38.72 34.47z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol